export default "__VITE_ASSET__Cjjf6kyK__"